var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title fix_width"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.main))]),_c('p',[_vm._v(_vm._s(_vm.sub))])]),_c('img',{attrs:{"src":_vm.getImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }